export default __webpack_public_path__ + "static/media/uefa-predic.23bc5454.webp";